export const reviews = [
  {
    id: 1,
    name: '陈小姐',
    role: '互联网运营',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%20in%20casual%20office%20attire%20against%20soft%20neutral%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20headshot%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '凌晨两点被deadline逼到崩溃，胃疼又焦虑。在凌晨不打烊下了个热粥单，还顺便打了一通心理咨询热线。配送小哥超快送到，咨询师也很专业耐心。那个凌晨因为凌晨不打烊变得没那么难熬了。',
    date: '2026-08-06',
  },
  {
    id: 2,
    name: '王先生',
    role: '创业者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20in%20his%2030s%20with%20confident%20expression%2C%20business%20casual%20style%2C%20clean%20studio%20portrait%20with%20soft%20warm%20lighting%2C%20approachable%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '服务器凌晨宕机，客户电话打爆了。凌晨不打烊的IT技术支持15分钟就响应了，远程排查+修复一气呵成。要不是有他们，那次故障我可能就丢了一个大客户。真心感谢！',
    date: '2026-08-04',
  },
  {
    id: 3,
    name: '李阿姨',
    role: '退休教师',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20elderly%20Asian%20woman%20with%20kind%20gentle%20smile%2C%20silver%20hair%2C%20soft%20natural%20lighting%2C%20cozy%20home%20setting%2C%20heartwarming%20expression%2C%20clean%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '子女都在国外，我一个人住。有天凌晨心慌得不行，试着在凌晨不打烊上问了在线医生。医生特别耐心，指导我用药休息，还叮嘱了很多注意事项。凌晨有人关心，真的特别温暖。',
    date: '2026-08-02',
  },
  {
    id: 4,
    name: '赵同学',
    role: '研究生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20student%20portrait%20with%20bright%20eyes%20and%20gentle%20smile%2C%20casual%20style%2C%20clean%20minimal%20background%2C%20natural%20daylight%2C%20fresh%20and%20youthful%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '论文deadline前夜，统计方法卡住了。凌晨不打烊的学习辅导老师凌晨还在线，帮我把难点讲得清清楚楚。凌晨三点交完论文的那一刻，真心感谢凌晨还有这样的服务。',
    date: '2026-07-30',
  },
  {
    id: 5,
    name: '刘先生',
    role: '自由职业者',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20Asian%20man%20in%20early%2030s%20with%20friendly%20relaxed%20expression%2C%20wearing%20simple%20t-shirt%2C%20modern%20urban%20coffee%20shop%20background%2C%20warm%20tone%20photography&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 4,
    content: '凌晨出门倒垃圾，门被风吹关上了，手机钥匙全在里面。凌晨不打烊的紧急开锁师傅25分钟就到了，专业工具无损开门，没有破坏锁芯。凌晨的救命稻草，名不虚传！',
    date: '2026-07-28',
  },
  {
    id: 6,
    name: '张女士',
    role: '新手妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20maternal%20portrait%20of%20young%20Asian%20mother%20with%20tender%20smile%2C%20soft%20comfy%20home%20setting%2C%20natural%20window%20light%2C%20gentle%20nurturing%20expression%2C%20clean%20headshot%20photography&width=120&height=120&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '宝宝凌晨发高烧，老公出差，我一个人急得直哭。凌晨不打烊的在线医生视频诊断后指导我物理降温，还帮我联系了最近的24小时药房送药。那个凌晨是凌晨不打烊给了我定心丸。',
    date: '2026-07-25',
  },
];